/* Maison Tanin : apparitions au défilement, compteurs, carrousel d'avis */
(function () {
  if (window.__mtInit) return; window.__mtInit = true;
  document.documentElement.classList.add('mt-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var end = parseFloat(el.dataset.count), dec = (el.dataset.count.split('.')[1] || '').length, sep = el.dataset.sep || ',';
    if (reduce || isNaN(end)) return;
    var t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), v = end * (1 - Math.pow(1 - p, 3));
      el.firstChild.nodeValue = v.toFixed(dec).replace('.', sep);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init() {
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('[data-count]').forEach(countUp);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' }) : null;
    document.querySelectorAll('.mt-reveal').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });

    document.querySelectorAll('[data-mt-track]').forEach(function (wrap) {
      var track = wrap.querySelector('.mt-track');
      wrap.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.querySelector('.mt-review');
          track.scrollBy({ left: (card ? card.offsetWidth + 20 : 300) * +b.dataset.dir, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
